import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "./assets/css/bootstrap.min.css";
import "./assets/css/main.css";
import "./assets/css/owl.carousel.css";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import store, { persistor } from "./store/store";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { GoogleOAuthProvider } from "@react-oauth/google";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <GoogleOAuthProvider clientId="657305180305-1qs17b93eh5l5v8urt7148d5ek9mt8lr.apps.googleusercontent.com">
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
        <ToastContainer style={{ zIndex: 9999999 }} />
      </PersistGate>
    </Provider>
  </GoogleOAuthProvider>
  // </React.StrictMode>,
);
